<template lang="pug">
	span.compression-data
		span(v-if="isProcessing")
			span.compression-info Size:
				.icon.fa.fa-spinner.fa-spin
		span(v-else)
			span.compression-error(v-if="isError && isError.indexOf('TexturePacker::') > 0" v-html="isError.substr(isError.indexOf('TexturePacker::') + 16).replace(/TexturePacker::/g, '<br>')")
			span.compression-error(v-else-if="isError") Error: {{ isError }}
			span.compression-info(v-else-if="!isUnknown") {{ (this.sizeText || 'Size: ') + (new Intl.NumberFormat().format(Math.round(size / 1000))) }} kb
			span.compression-info(v-else="isUnknown") Asset size unknown
		span.unknown-button(v-if="isUnknown" v-b-tooltip.hover="{delay: { show: 1500, hide: 100 }, title: 'Repack and calculate size'}" v-on:click="compressAssets()")
			li.fa.fa-refresh
</template>

<script>

	import Screen 				from './../../mixins/screen';

	import { Asset } 			from '../../services/Asset';
	import { Monitoring } 		from './../../services/Monitoring';

	export default {
		name: "AssetCompressionData",
		mixins: [Screen],
		screen: {
			updateOn: [],
			events: {
				"Active Processes Changed": function(process_data) {

					if (process_data.type === 'asset-compress') this.update();

				}
			}
		},
		props: ['sizeText', 'assets'/*, 'compression', 'repack'*/],
		data() {

			this.Monitoring = Monitoring;

			return {
				showed: true
			};

		},
		computed: {
			size() {

				let size = 0;

				_.each(this.assets, asset => {

					if (asset.compressionData && !asset.compressionData.error) size += asset.compressionData.size;

				});

				return size;

			},
			isProcessing() {

				let is_processing = false;

				_.each(this.assets, asset => {

					if (Monitoring.activeProcesses['asset-compress'][asset.id]) is_processing = true;

				});

				return is_processing;

			},
			isUnknown() {

				let is_unknown = false;

				_.each(this.assets, asset => {

					if (!asset.compressionData) is_unknown = true;

				});

				return is_unknown;

			},
			isError() {

				let is_error = false;

				_.each(this.assets, asset => {

					if (asset.compressionData && asset.compressionData.error) is_error = asset.compressionData.error;

				});

				return is_error;

			}
		},
		methods: {
			compressAssets() {

				Asset.compressAssets(_.map(this.assets, 'id'));

			}
		}
	}
</script>

<style lang="sass">

	.compression-data
		line-height: 11px

		.compression-error
			line-height: 11px
			color: #f86c6b

		.compression-info
			line-height: 24px

		.fa-spinner.fa-spin
			margin: 0 5px 0 5px

		.unknown-button
			cursor: pointer
			transition: 0.2s
			padding: 2px 7px
			font-size: 14px
			color: #fff

			&:hover
				color: #20a8d8

</style>

